import {createSelector} from '@reduxjs/toolkit';
import {RootState} from '../store';
import {THUNK_STATUS} from '../../domain/types';

const audioSelector = (state: RootState) => state.audio;

export const audioDataSelector = (state: RootState) => audioSelector(state).data;
export const audioApiStatusSelector = (state: RootState) => audioSelector(state).api.status;
export const selectedAudioIdSelector = (state: RootState) => audioSelector(state).selectedAudioId;
export const uploadRequestIdSelector = (state: RootState) => audioSelector(state).uploadRequestId;

export const audioUploadStateSelector = (state: RootState) => audioSelector(state).upload;
export const uploadPhaseSelector = (state: RootState) => audioUploadStateSelector(state).phase;
export const uploadProgressSelector = (state: RootState) => audioUploadStateSelector(state).progress;
export const uploadErrorSelector = (state: RootState) => audioUploadStateSelector(state).error;
/**
 * The row bytes are currently going into, or null.
 *
 * Uploads are resumable, so a `pending` row is on screen the whole time one is running — this is
 * what stops that row offering "Resume" for the upload already in progress.
 */
export const uploadingAudioIdSelector = (state: RootState) => audioUploadStateSelector(state).audioId;

export const audioIsLoadingSelector = createSelector(
  [audioApiStatusSelector],
  status => status === THUNK_STATUS.pending
);

export const isUploadingSelector = createSelector(
  [audioUploadStateSelector],
  upload => upload.status === THUNK_STATUS.pending
);

/** Only `ready` uploads can be transcribed — a `pending` one has parts still to go. */
export const readyAudioSelector = createSelector(
  [audioDataSelector],
  uploads => uploads.filter(upload => upload.status === 'ready')
);

export const selectedAudioSelector = createSelector(
  [audioDataSelector, selectedAudioIdSelector],
  (uploads, selectedId) => uploads.find(upload => upload.id === selectedId) ?? null
);
